// TODO: Убрать старые пропы в снейк кейсе после перевода новостей на новое апи
// TODO: Исправить типизацию

/* @flow */

import React from 'react';

import type { Node } from 'react';
import type { TArticle, TNews, TCategory } from '../../types/articles';

// import FavoriteBtn from '../FavoriteBtn';
import Link from '../Link';
import Tile from '../Tile';

import { mapCategoryIdToTitle } from '../../utils/articles';

import { Root as TilesList } from '../TilesObjects/styles';
import { Info, Label, Text, Title } from '../Tile/styles';

type TSection = 'znanie' | 'news';

type Props = {
	categoryList?: Array<TCategory>,
	data: Array<TArticle> | Array<TNews>,
	section: TSection,
};

const getLink = (section: TSection, slug: string) => `/${section}/${slug}/`;

const TilesArticles = ({ data, section, categoryList }: Props): Node => {
	const CATEGORY_IDS = categoryList && mapCategoryIdToTitle(categoryList);

	return (
		<TilesList $twoColumn>
			{data.map((item) => {
				const titleFromParentCategory =
					item.category && item.category.parentId && CATEGORY_IDS && CATEGORY_IDS[item.category.parentId];
				const titleFromCategory = item.category_id && CATEGORY_IDS && CATEGORY_IDS[item.category_id];

				return (
					<Tile key={item.slug} type="wide" noImage>
						{/* <FavoriteBtn id={item.id} type={this.props.news ? "news" : "knowledge"} /> */}
						<Link to={getLink(section, item.code || item.slug)}>
							<Info $noImage>
								{(titleFromParentCategory || titleFromCategory) && (
									<Label>{titleFromParentCategory || titleFromCategory}</Label>
								)}

								{item.title && <Title>{item.title}</Title>}

								{(item.preview_desc || item.previewDescription) && (
									<Text
										// eslint-disable-next-line react/no-danger
										dangerouslySetInnerHTML={{
											__html: item.preview_desc || item.previewDescription,
										}}
									/>
								)}
							</Info>
						</Link>
					</Tile>
				);
			})}
		</TilesList>
	);
};

TilesArticles.defaultProps = {
	categoryList: null,
};

export default TilesArticles;
